enum Environment {
  Development = "development",
  Production = "production",
}

const helpers = {
  [Environment.Development]: {
    api: process.env.NEXT_PUBLIC_API_DEV_URL || "-",
    support: {
      url: process.env.NEXT_PUBLIC_SUPPORT_URL || "-",
      organization: process.env.NEXT_PUBLIC_SUPPORT_ORGANIZATION || "-",
      secretKey: process.env.NEXT_PUBLIC_SUPPORT_SECRET_KEY || "-",
    },
  },
  [Environment.Production]: {
    api: process.env.NEXT_PUBLIC_API_PROD_URL || "-",
    support: {
      url: process.env.NEXT_PUBLIC_SUPPORT_URL || "-",
      organization: process.env.NEXT_PUBLIC_SUPPORT_ORGANIZATION || "-",
      secretKey: process.env.NEXT_PUBLIC_SUPPORT_SECRET_KEY || "-",
    },
  },
};

export const getEnvironment = () => {
  const key =
    (process.env.NEXT_PUBLIC_ENVIRONMENT as Environment) || "development";
  return helpers[key];
};

export const getOnlyOfficeUrl = () => {
  return process.env.NEXT_PUBLIC_ONLYOFFICE_URL || "-";
};
